import React from "react";
import { Pressable, View, Text, Image } from "react-native";
import * as WebBrowser from "expo-web-browser";

// Import assets for web compatibility
import appleLogo from "../../../assets/AppleLogoBlack32px.png";

import { AppleAuthButtonMobileProps } from "./AppleAuthButtonMobile";

const AppleAuthButton: React.FC<AppleAuthButtonMobileProps> = ({ RBRef, onSubmit }) => {
  const startAppleAuth = async () => {
    try {
      const authUrl = `${process.env.REACT_NATIVE_API_BASE_URL}apple/oauth2/init/web`;
      const result = await WebBrowser.openAuthSessionAsync(authUrl);

      if (result.type === "success") {
        console.log("Apple OAuth flow complete.");
        // For web, we need to handle the callback URL and extract user data
        // For now, we'll use a placeholder approach
        if (onSubmit) {
          onSubmit('apple_user@example.com', 'web_apple_token', 'apple');
        }
        // Use the correct @gorhom/bottom-sheet API method
        if (RBRef?.current && typeof RBRef.current.dismiss === 'function') {
          RBRef.current.dismiss();
        }
      } else {
        console.log("Apple OAuth flow cancelled or failed.");
        // Use the correct @gorhom/bottom-sheet API method
        if (RBRef?.current && typeof RBRef.current.dismiss === 'function') {
          RBRef.current.dismiss();
        }
      }
    } catch (error) {
      console.error('Apple Auth Web Error:', error);
      // Use the correct @gorhom/bottom-sheet API method
      if (RBRef?.current && typeof RBRef.current.dismiss === 'function') {
        RBRef.current.dismiss();
      }
    }
  };

  return (
    <Pressable onPress={startAppleAuth}>
      <View className="flex-row justify-center items-center px-4 py-3 my-1 bg-black rounded-full">
        <Image
          source={appleLogo} // Adjust the path to your PNG file
          style={{
            width: 24, // Desired width of the image
            height: 24, // Desired height of the image
          }}
          tintColor={"white"}
          resizeMode="contain" // Ensures the image scales properly without being cropped
        />
        <Text className="ml-4 text-lg font-medium text-white">
          Continue with Apple
        </Text>
      </View>
    </Pressable>
  );
};

export default AppleAuthButton;
